export enum ServiceCode {
  CommercialRecycling = 'S1003',
  CommercialTrashAndRecycling = 'S1013',
  CommercialBulk = 'S1001',
  CommercialFoodWaste = 'S1007',
  CommercialTrash = 'S1009',
  BulkPickupTownServiceDetailDto = 'S0001',
  FoodWasteTownServiceDetailDto = 'S0007',
  TrashPickUpTownServiceDetailDto = 'S0009',
  TrashPickUpAndRecyclingTownServiceDetailDto = 'S0013',
  RecyclingTownServiceDetailDto = 'S0023',
  RollOff = 'S0005',
}
